
  export default {
    name: 'main-footer',
  };
